import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import CardItemExternal from './CardItemExternal'

function Cards() {
  
  return (
    <div className='cards'>
      <h3>Explore Kelowna’s hidden mural gems!</h3>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItemExternal
              src='images/Spítləm Sisters.jpg'
              text="View Murals"
              label='Mural Map'
              path='https://experience.arcgis.com/experience/ae1bfe36c4d7480c876e24475c34d6e4'
            />
            <CardItem
              src='images/survey123.jpg'
              text="Submit a New Mural, Feedback, or Correction"
              label='Mural Survey'
              path='/survey'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
